module.exports = __webpack_public_path__ + "static/media/bloom18.4e8f2e91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blooming/bloom18.jpg
// module id = 634
// module chunks = 0